import { render, staticRenderFns } from "./IdeaPage.vue?vue&type=template&id=5449ec66&scoped=true&"
import script from "./IdeaPage.vue?vue&type=script&lang=js&"
export * from "./IdeaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449ec66",
  null
  
)

export default component.exports